import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import {languages} from '../../utils/localizations';
import { withTranslation } from 'react-i18next';

const LanguageMenuStyled = styled.select`
    position: ${props => props.position ? props.position  : 'fixed'};
    right: 20px;
    top: ${props => props.top ? props.top : '15px'};
    bottom: ${props => props.bottom ? props.bottom : 'unset'};
    height: 30px;
    margin: auto;
    background: #333;
    color: white;
    border-radius: 5px;
    border-color: #444;

    &:hover {
        background: #111;
        border-color: #ccc;
    }

    &:focus {
        background: #111;
        border-color: #ccc;
        outline: none;
        box-shadow: none;
    }

    &::-ms-expand {
        display: none;
    }
`;

const LanguageMenu = (props) => {
    const[language, setLanguage] = useState('uk');

    useEffect(() => {
        const lang = props.i18n.language;
        if (!lang) {
            updateLanguage("uk");
        }
        else if (lang.length > 2) {
            let temp = lang.substring(0, 2);
            if (languages.indexOf(temp) === -1) {
                updateLanguage("uk");
            } else {
                updateLanguage("uk");
            }
        }
        else {
            setLanguage(lang);
        }
    }, [])

    const updateLanguage = (lang) => {
        setLanguage(lang);
        props.i18n.changeLanguage(lang)
    }

    return (
    <>
        <LanguageMenuStyled {...props} onChange={(e) => updateLanguage(e.target.value)} value={language}>
            {languages.map((language, index) =>
                            <option key={index} value={language.key}>{language.value}</option>
                        )}
        </LanguageMenuStyled>
    </>
    )
}

export default withTranslation('translantions')(LanguageMenu);